import {Fancybox} from '@fancyapps/ui'

global.Fancybox = window.Fancybox = Fancybox

var resizeIntervalId = null

let defaultOptions = {
    on: {
        reveal: (fancybox, eventName) => {
            resizeIntervalId = setInterval(function (){
                Fancybox.resize()
            }, 100)
        },
        destroy: (fancybox, eventName) => {
            clearInterval(resizeIntervalId)
        },
        close: (fancybox, eventName) => {
            if($(fancybox.getSlide().triggerEl).is('[data-after-close-reload]')){
                parent.location.reload()
                window.sessionStorage.setItem('skip-onload-open', 'true')
            }
        }
    }
}

Fancybox.bind("[data-fancybox]", defaultOptions);

$('body').on('click', '[data-dismiss="fancybox"]', function(e) {
    parent.Fancybox.close();
})


let skipOnloadOpen = window.sessionStorage.getItem('skip-onload-open')
if(skipOnloadOpen !== 'true'){
    let $onloadOpen = $('[data-fancybox][data-onload-open]');
    if($onloadOpen.length){
        Fancybox.fromNodes([$onloadOpen[0]], defaultOptions)
    }
}
window.sessionStorage.removeItem('skip-onload-open')




Fancybox.resize = function(options) {
    //let iframeH = Fancybox.getSlide().iframeEl.contentWindow.innerHeight
    console.log("resizeFancybox")

    if(!Fancybox.getSlide()){
        return
    }
    let iframeH = Fancybox.getSlide().iframeEl.contentDocument.body.clientHeight
    let $fancyboxContent = $(Fancybox.getSlide().el).find('.fancybox__content')
    let s = window.getComputedStyle($fancyboxContent[0])
    let paddingTop = parseInt(s.getPropertyValue('padding-top'))
    let paddingBottom = parseInt(s.getPropertyValue('padding-bottom'))

    $fancyboxContent.height(paddingTop + iframeH + paddingBottom)
}